<template>
  <a-select :placeholder="placeholder" :value="value" @change="handleInput">
    <a-select-option value="">请选择</a-select-option>
    <a-select-option v-for="(item, key) in dictOptions" :key="key" :value="item.value" :dataText="item.text">{{ item.text }}</a-select-option>
  </a-select>
</template>

<script>
  import {ajaxGetDictItems} from '@/api/api'

  export default {
    name: "DictSelectTag",
    props: {
      dictCode: String,
      placeholder: String,
      value: String,// 1.接收一个 value prop
      triggerChange: Boolean  //v-model时，不要设置trigger-change。v-decorator时，需要设置trigger-change，才能赋值成功。
    },
    data() {
      return {
        dictOptions: [],
      }
    },
    created() {
      // console.log(this.dictCode);
      //获取字典数据
      this.initDictData();
    },
    methods: {
      initDictData() {
        //根据字典Code, 初始化字典数组
        ajaxGetDictItems(this.dictCode, null).then((res) => {
          if (res.success) {
//                console.log(res.result);
            this.dictOptions = res.result;
          }
        })
      },
      handleInput(val, option) {
        //console.log(val);
        if (this.triggerChange) {
          this.$emit('change', val, option); // 1.v-decorator触发 change 事件，并传入新值
        } else {
          this.$emit('input', val, option); // 2.v-mode触发 input 事件，并传入新值
        }
      }
    }
  }
</script>

<style scoped>
</style>